/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './ui/__generated__/SupportWebsiteNavEntryPointQuery$parameters';
import type { SupportWebsiteNavEntryPointQuery } from './ui/__generated__/SupportWebsiteNavEntryPointQuery.graphql.ts';

type HorizontalNavigationCsmSupportWebsiteEntryPointComponent = EntryPointComponent<
	{
		SupportWebsiteNavEntryPointQuery: SupportWebsiteNavEntryPointQuery;
	},
	{},
	{},
	{} | null
>;

export const horizontalNavigationCsmSupportWebsiteEntryPoint: EntryPoint<
	HorizontalNavigationCsmSupportWebsiteEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<HorizontalNavigationCsmSupportWebsiteEntryPointComponent>(
		/* webpackChunkName: "async-horizontal-navigation-csm-support-website-entrypoint" */ './ui/SupportWebsiteNavEntryPoint.tsx',
		{
			includeInShellOnlySsrBundle: true,
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({
		context: {
			match: {
				params: { helpCenterId },
			},
		},
		tenantContext: { cloudId, activationId },
	}: EntryPointRouteParams) => {
		return {
			queries: {
				SupportWebsiteNavEntryPointQuery: {
					parameters,
					variables: {
						cloudId,
						helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
					},
					options: {
						fetchPolicy: 'store-or-network' as const,
					},
				},
			},
		};
	},
});
